
import { Component, Prop, Vue } from "vue-property-decorator"
import { Require } from "@coredination/components"
import { BeforeInstallPromptEvent } from "vue-pwa-install"

@Component({
    components: { Require },
})
export default class Menu extends Vue {
    showInstall = false // TODO same as in App.vue

    get version() {
        try {
            return require("../../package.json").version
        } catch (error) {
            console.error("couldn't load package version", error)
        }
    }

    created() {
        this.$on("canInstall", (event: BeforeInstallPromptEvent) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt:
            event.preventDefault()
            this.showInstall = true
        })

    }

    install() {
        this.$root.$emit("install")
    }

    logout() {
        this.$root.$emit("logout")
    }

    iosWrapperClient() {
        return Vue.prototype.$iosWrapperClient
    }

    get androidWrapperVersion() {
        return localStorage.getItem('android-wrapper-version')
    }
    get iosWrapperVersion() {
        return localStorage.getItem("ios-wrapper-version")
    }
}
